
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgContactCallPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 31,
  viewBox: "0 0 31 31"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "contact-call-phone_5d332dba45ecacb1__a"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.443137 0 0 0 0 0.090196 0 0 0 0 0.411765 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#contact-call-phone_5d332dba45ecacb1__a)",
  transform: "translate(-11 -11)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m40.532 33.123-4.11-4.001c-.631-.702-2.317-1.58-4.318-.351-.105.07-.175.105-.246.175l-1.65 1.65c-1.685-1.018-5.371-3.616-7.408-7.408l1.124-1.123c.246-.246 1.229-1.229 1.264-2.668.035-.702-.14-1.756-1.23-2.844l-4.036-4.003c-.07-.07-.105-.106-.175-.14-.808-.563-2.809-1.265-4.6.315-.175.14-4.072 3.51-2.878 9.163.035.492.245 1.896 1.299 4.038 1.615 3.195 4.353 6.53 8.215 9.9.21.176 5.196 4.46 10.954 5.302.176.035.702.14 1.44.14 1.58 0 4.142-.42 6.179-2.738.35-.28 1.053-1.053 1.228-2.212.106-.702 0-1.79-.983-3.02 0-.105-.035-.14-.07-.175zm-1.967 3.23c-.105.07-.14.106-.246.21-2 2.388-4.915 1.791-5.02 1.791-.035 0-.07 0-.106-.035-4.915-.737-9.514-4.634-9.55-4.67-8.18-7.161-8.566-11.936-8.566-12.041 0-.106 0-.176-.035-.281-.913-4.003 1.79-6.425 1.931-6.53.457-.387.878-.317 1.089-.176l3.932 3.897c.28.28.386.527.386.737 0 .316-.28.632-.351.702l-.07.07-1.861 1.897c-.421.42-.527 1.018-.281 1.58 2.809 6.354 9.69 9.935 9.97 10.11a1.386 1.386 0 0 0 1.616-.245l2.317-2.247c.281-.14.527-.175.667-.035l.07.07 4.038 3.932c.28.351.562.878.07 1.264z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"31\" height=\"31\" viewBox=\"0 0 31 31\">\r\n    <defs>\r\n        <filter id=\"58kblr88ua\">\r\n            <feColorMatrix in=\"SourceGraphic\" values=\"0 0 0 0 0.443137 0 0 0 0 0.090196 0 0 0 0 0.411765 0 0 0 1.000000 0\"/>\r\n        </filter>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g>\r\n                <g>\r\n                    <g>\r\n                        <g filter=\"url(#58kblr88ua)\" transform=\"translate(-174 -525) translate(0 64) translate(19 113) translate(141 337) translate(3)\">\r\n                            <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n                                <path d=\"M28.79 21.381L24.68 17.38c-.631-.702-2.317-1.58-4.318-.351-.105.07-.175.105-.246.175l-1.65 1.65c-1.685-1.018-5.371-3.616-7.408-7.408l1.124-1.123c.246-.246 1.229-1.229 1.264-2.668.035-.702-.14-1.756-1.23-2.844L8.18.808c-.07-.07-.105-.106-.175-.14-.808-.563-2.809-1.265-4.6.315-.175.14-4.072 3.51-2.878 9.163.035.492.245 1.896 1.299 4.038 1.615 3.195 4.353 6.53 8.215 9.9.21.176 5.196 4.46 10.954 5.302.176.035.702.14 1.44.14 1.58 0 4.142-.42 6.179-2.738.35-.28 1.053-1.053 1.228-2.212.106-.702 0-1.79-.983-3.02 0-.105-.035-.14-.07-.175zm-1.967 3.23c-.105.07-.14.106-.246.21-2 2.388-4.915 1.791-5.02 1.791-.035 0-.07 0-.106-.035-4.915-.737-9.514-4.634-9.55-4.67-8.18-7.161-8.566-11.936-8.566-12.041 0-.106 0-.176-.035-.281-.913-4.003 1.79-6.425 1.931-6.53.457-.387.878-.317 1.089-.176l3.932 3.897c.28.28.386.527.386.737 0 .316-.28.632-.351.702l-.07.07-1.861 1.897c-.421.42-.527 1.018-.281 1.58 2.809 6.354 9.69 9.935 9.97 10.11.528.282 1.195.176 1.616-.245l2.317-2.247c.281-.14.527-.175.667-.035l.07.07 4.038 3.932c.28.351.562.878.07 1.264z\" transform=\"translate(11.742 11.742)\"/>\r\n                            </g>\r\n                        </g>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/contact-call-phone.5d332dba45ecacb1d2ea1b3bf5c0b38d.svg"),
        {
          React: SvgContactCallPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      